import React, { Component } from "react";
import Http from "../../../Http";
import Pdf from '../../../components/pdfViewer'
import { Button, CircularProgress } from "@material-ui/core";

export default class DescargarDeposito extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pdfURL: null,
      mailLoading: false,
      loadingpdf: true,
      sbOpen: false,
      sbMsg: "",
      filename: "",
      groups: [],
      loadingButton: false,
      isPdfSelected: false,
    };
  }

  async componentDidMount() {
    const { deposito } = this.props;
    this.setState({
      deposito,
      filename: `deposito_${deposito.id}`,
    },
      () => {
        // this.getPDF();
        this.getAllFiles();
      }
    );
  }

  getAllFiles = async () => {
    const { deposito } = this.props;
    try {
      let res = await Http.get(`deposito/${deposito.id}/files`);
      console.log(res)
      this.setState({ groups: res.data });
      if (res.data.length > 0) {
        this.setState({
          isPdfSelected: res.data[0].id,
          loadingpdf: true,
        }, () => this.getPDF(res.data[0].id))
      }
    } catch (error) {
      console.log(error);
    }
  }

  onGrupoItemClick = (group) => {
    console.log(group);
    if (group.id === this.state.isPdfSelected) return;
    // const { pdfURL } = this.state;
    // window.URL.revokeObjectURL(pdfURL);
    this.setState({
      isPdfSelected: group.id,
      loadingpdf: true,
      pdfURL: null,
    }, () => this.getPDF(group.id))
  }

  getPDF = async (grupo_id) => {
    console.log(grupo_id)
    const { deposito } = this.state;
    const Resp = await Http.post(`deposito/file`, {
      type: "pdf",
      id_deposito: deposito.id,
      id_pago_grupo: grupo_id,
    }, true, "arraybuffer");
    let response = null;
    try {
      let decodedString = String.fromCharCode.apply(null, new Uint8Array(Resp));
      response = JSON.parse(decodedString);
    } catch (error) {
      console.log(error);
    }
    if (response && response.error) {
      this.setState({
        loadingpdf: false,
        sbOpen: true,
        sbMsg: response.errMsg,
      });
    } else {
      const blob = new Blob([Resp], { type: "application/pdf" });
      this.setState({ loadingpdf: false, pdfURL: URL.createObjectURL(blob) });
    }
  };

  handledownloadPdf = () => {
    const { pdfURL, filename } = this.state;
    this.setState({ loadingButton: true });
    let namepdf = `${filename}.pdf`;
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = `${pdfURL}`;
    a.download = namepdf;
    document.body.appendChild(a);
    a.click();
    this.setState({ loadingButton: false });
  };

  handledownloadFile = async (type) => {
    const { deposito, filename, isPdfSelected } = this.state;
    this.setState({ loadingButton: true });
    const Resp = await Http.post("deposito/file", { type, id_deposito: deposito.id, id_pago_grupo: isPdfSelected }, true, "arraybuffer");
    let response = null;
    try {
      let decodedString = String.fromCharCode.apply(null, new Uint8Array(Resp));
      response = JSON.parse(decodedString);
    } catch (error) {
      console.log(error);
    }
    if (response && response.error) {
      this.setState({
        loadingpdf: false,
        sbOpen: true,
        sbMsg: response.errMsg,
      });
    } else {
      let xmlfile = `XML_${filename}.xml`;
      const blob = new Blob([Resp], { type: "application/xml" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = xmlfile;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    }
    this.setState({ loadingButton: false });
  };

  handleDownloadFiles = async () => {
    const { deposito, id_cliente } = this.props;
    const Resp = await Http.post(`deposito/email`, { id_cliente, id_deposito: deposito.id, id_grupo: this.state.isPdfSelected });
    if (!Resp.error) {
      this.setState({ sbMsg: 'Correos enviados', sbOpen: true });
    } else {
      this.setState({ sbMsg: 'Error al enviar los correos', sbOpen: true });
    }
  };

  componentWillUnmount() {
    const { pdfURL } = this.state;
    window.URL.revokeObjectURL(pdfURL);
  }

  render() {
    const { pdfURL, loadingpdf, loadingButton, isPdfSelected, groups } = this.state;

    return (
      <div style={{ minHeight: 300 }}>
        <div className='d-flex justify-content-center mb-3'>
          {
            groups.length > 1 && groups.map(group => (
              <div onClick={() => this.onGrupoItemClick(group)} key={group.nombre}
                className={`mx-2 px-5 py-2 rounded ${isPdfSelected === group.id ? 'bg-dark' : 'bg-secondary'}`}
                style={{ cursor: 'pointer' }}>
                <p className='m-0 text-light'>Factura {group.nombre}</p>
              </div>
            ))
          }
        </div>

        {
          isPdfSelected && (
            <>
              {loadingpdf && (
                <div className={`overlay`}>
                  <CircularProgress size={200} />
                </div>
              )}
              {pdfURL && (
                <div className="pdf-viewer">
                  <Pdf
                    minWidth={750}
                    pdfUrl={pdfURL}
                  />
                </div>
              )}
              {pdfURL && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    padding: 10,
                  }}
                >
                  <Button variant="contained" onClick={this.handledownloadPdf} disabled={loadingButton} >
                    <div style={{ marginRight: 10, padding: 0, height: 22 }} hidden={!loadingButton}>
                      <CircularProgress color="secondary" size={20} />
                    </div>
                    Descargar PDF
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => this.handledownloadFile("xml-timbrado")}
                    disabled={loadingButton}
                  >
                    <div style={{ marginRight: 10, padding: 0, height: 22 }} hidden={!loadingButton}>
                      <CircularProgress color="secondary" size={20} />
                    </div>
                    Descargar XML
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => this.handleDownloadFiles()}
                  >
                    Reenviar Correo
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => {this.props.onClose && this.props.onClose() }}
                  >
                    Cerrar
                  </Button>
                </div>
              )}
            </>
          )
        }
      </div>
    );
  }
}
